// extracted by mini-css-extract-plugin
module.exports = {"section":"contact-module--section--2l_be","main":"contact-module--main--2JkgR","titleWrap":"contact-module--titleWrap--3vivJ"};